var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1680855673843,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12859,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M934.4 906.666667H55.466667c-17.066667 0-32-14.933333-32-32s14.933333-32 32-32h876.8c17.066667 0 32 14.933333 32 32s-12.8 32-29.866667 32zM806.4 354.133333c-6.4 0-14.933333-2.133333-21.333333-8.533333L618.666667 204.8c-12.8-10.666667-14.933333-32-4.266667-44.8 10.666667-12.8 32-14.933333 44.8-4.266667l166.4 142.933334c12.8 10.666667 14.933333 32 4.266667 44.8-6.4 6.4-14.933333 10.666667-23.466667 10.666666z",
    fill: "#707070",
    "p-id": 12860
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.133333 800c-8.533333 0-19.2-4.266667-25.6-10.666667-12.8-10.666667-17.066667-27.733333-12.8-44.8l61.866667-211.2c8.533333-25.6 21.333333-46.933333 38.4-66.133333L676.266667 87.466667c25.6-29.866667 68.266667-32 96-8.533334l110.933333 93.866667c14.933333 12.8 23.466667 27.733333 23.466667 46.933333 2.133333 19.2-4.266667 36.266667-17.066667 49.066667l-322.133333 384c-17.066667 19.2-36.266667 34.133333-57.6 46.933333h-2.133334l-200.533333 96c-4.266667 2.133333-10.666667 4.266667-17.066667 4.266667z m23.466667-36.266667c0 2.133333 0 0 0 0z m-32-25.6s-2.133333 0-2.133333 2.133334l2.133333-2.133334zM727.466667 128c-2.133333 0-2.133333 0-4.266667 2.133333L398.933333 509.866667c-10.666667 12.8-19.2 27.733333-25.6 44.8l-46.933333 160 151.466667-72.533334c14.933333-8.533333 27.733333-19.2 38.4-32l324.266666-381.866666c0-2.133333 2.133333-2.133333 2.133334-4.266667 0 0 0-2.133333-2.133334-4.266667l-110.933333-93.866666c0 2.133333 0 2.133333-2.133333 2.133333zM494.933333 672z",
    fill: "#707070",
    "p-id": 12861
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisposal);
export default __webpack_public_path__ + "static/media/disposal.f09d928a.svg";
export { ForwardRef as ReactComponent };